// extracted by mini-css-extract-plugin
export default {"actionButtons":"G0NqVtA5KHyBXsYRKElR","body":"DMNs0GT1I8EeMIoyeqqS","featureList":"ZK1ZyYUQMlyLaBf6Oow0"};